// this file has too much data.
// we already have the name and display name
// we probably should just get all new images and use the ID as the image name.

/*
This data is now located in 
	CDN_URI/assets/js/modes/modes_data.js
so that the file may be edited without compilation
*/

export var modeData = window.modeData;
